{
  "positions": {
    "typesAssets": {
      "stocks": "Stocks",
      "options": "Options"
    }
  }
}
